import { Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SVGs } from "../assets";
import { Breadcrumbs, Card, Text } from "../components";
import { useNavigation } from "../hooks";
import { tabRoutes } from "../components/Header";

export type SubRouteBreadcrumbRule = {
  pattern: string;
  key: string;
};

export type SubRouteLayoutProps = {};

export default function SubRouteLayout() {
  const { t } = useTranslation();
  const navigation = useNavigation();
  const location = useLocation();
  const routes = tabRoutes(t);
  const crumbs = ("dashboard/" + location.pathname)
    .split("/")
    .map((path) => {
      const route = routes
        .map((item) => [item, ...item.routes])
        .flat()
        .find((item) => item.name === path);
      const label = route?.options?.title || navigation?.options?.title;
      return !!label && !!path && { label, path: route?.path };
    })
    .filter(Boolean);

  return (
    <div>
      <Breadcrumbs items={crumbs as any} className="sticky top-[80px] z-[90]" />
      <Card className="mx-[16px] mt-[16px] mb-[30px]">
        <button
          type="button"
          className="inline-flex items-center gap-[16px] cursor-pointer border-0 bg-transparent p-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30"
          onClick={() => navigation.goBack()}
        >
          <div className="flex justify-center items-center w-[40px] h-[40px] rounded-[30px] bg-background">
            <SVGs.LeftArrow className="h-4 w-4 text-secondary" />
          </div>
          <Text level={4} className="font-[700]">
            {t("general.back")}
          </Text>
        </button>
        <Outlet />
      </Card>
    </div>
  );
}
